module.exports = __webpack_public_path__ + "img/block_image_demo.e6f68bc9.png";